import { DocumentDataSourceOption } from './DocumentDataSourceOption';

/**
 * Single source of truth for combining a data-source option's `label` with its optional
 * `meta.unit` suffix (e.g. material-property units: "Area density" + "kg/m<sup>2</sup>").
 *
 * `meta.unit` may contain inline HTML (e.g. `<sup>2</sup>`) for a real superscript, so whenever
 * a unit is present the combined result must be rendered as rich text (`isHtmlRichText: true`)
 * everywhere it is used — EPD form controls, Version Log, and Version Comparison — so the three
 * surfaces stay visually identical.
 */
export interface FormattedOptionLabel {
  label: string;
  isHtmlRichText: boolean;
}

export const formatOptionLabelWithUnit = (
  option: DocumentDataSourceOption | undefined,
  fallback: string
): FormattedOptionLabel => {
  if (!option) {
    return { label: fallback, isHtmlRichText: false };
  }

  const unit = option.meta?.unit;
  if (!unit) {
    return { label: option.label, isHtmlRichText: false };
  }

  return { label: `${option.label} (${unit})`, isHtmlRichText: true };
};
